import { atom } from 'jotai'
import { propertyRecordsForPosition } from 'src/v2/state/owner-reveal/property-records'
import { selectedParcel } from 'src/v2/state/owner-reveal/sidebar'

export const parcelPropertyRecords = atom(async (get) => {
  const parcel = await get(selectedParcel)
  const position = parcel?.point?.geometry?.coordinates
  if (!position) {
    return undefined
  }

  const data = await get(propertyRecordsForPosition(position))
  return data?.[0]
})
